var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGhostbusters = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.001 20.998a5.97 5.97 0 0 1-3.473-1.115l8.356-8.356A5.96 5.96 0 0 1 21 14.999a6.006 6.006 0 0 1-5.999 5.999m0-11.998a5.96 5.96 0 0 1 3.468 1.113l-8.355 8.356A5.97 5.97 0 0 1 9 14.999 6.007 6.007 0 0 1 15.001 9m0-2C10.589 7 7 10.588 7 14.999s3.589 7.999 8.001 7.999S23 19.41 23 14.999 19.412 7 15.001 7"
})));
export default SvgGhostbusters;